import { View, Text, StyleSheet } from 'react-native'
import { Image } from 'expo-image'
import { router } from 'expo-router'
import { StandaloneWrapper } from '@/src/common/wrappers/StandaloneWrapper'
import { mesaColorNames, typography } from '@/src/common/theme'
import { Button } from '@/src/common/components/Button'
import { DesignSystem } from '@/src/design-system'
import { useEffect } from 'react'
import { randomUUID } from '@/src/common/utils/randomUUID'
import * as Stores from '../stores'
import * as Navigation from '../navigation'

export function PartnerDetailScreen() {
  const { setSelectedPartner, setIdempotencyKey, clear } = Stores.usePointsToOmniStore()

  useEffect(() => {
    clear()
    setIdempotencyKey(randomUUID())
    setSelectedPartner('OMNI')
  }, [clear, setIdempotencyKey, setSelectedPartner])

  const handleContinue = () => {
    router.push(Navigation.Routes.PointsTransfer.route)
  }

  return (
    <StandaloneWrapper
      screen={Navigation.Routes.PartnerDetail.route}
      title="Omni Hotels & Resorts"
      profileProps={{ menuIconProps: { color: mesaColorNames['Mesa - Brand/White #FFFFFF'] } }}
      hideBackButton={false}
    >
      <View style={styles.container}>
        <DesignSystem.SplitCard>
          <DesignSystem.SplitCard.ImageHeader containerStyle={{ height: 180 }}>
            <Image
              source={require('@/src/assets/images/omni_header.png')}
              contentFit="cover"
              style={{ height: 180 }}
            />
          </DesignSystem.SplitCard.ImageHeader>
          <DesignSystem.SplitCard.Content>
            <View style={styles.partnerInfo}>
              <Text style={typography['heading/heading3']}>Omni Hotels & Resorts</Text>
              <Text style={[typography['S'], styles.partnerDescription]}>
                Earn rewards at 50+ destinations from coast to coast every night you stay with Omni,
                and every time you take advantage of Omni's on-property experiences. Omni is
                committed to making every stay a memorable one, which is why you get immediate
                benefits as soon as you become a Select Guest.
              </Text>
            </View>
          </DesignSystem.SplitCard.Content>
        </DesignSystem.SplitCard>

        <DesignSystem.Card style={{ padding: 16, borderRadius: 12 }}>
          <DesignSystem.Accordion trigger="How does this work?">
            <DesignSystem.Markdown
              style={{
                body: {
                  ...typography['paragraph/sm'],
                  color: mesaColorNames['Mesa - Brand/Blackish #222222'],
                },
              }}
              children={
                'You can transfer Mesa Points to partners which you have connected and validated your accounts with. To perform a transfer, first link your account, then select the amount of Mesa Points which you would like to transfer. Points transfer is instant and not reversible. If you have issues please reach out to support@mesamember.com or  to the partner which the Mesa Points were transferred to.'
              }
            />
          </DesignSystem.Accordion>
        </DesignSystem.Card>
      </View>

      <Button title="Continue" onPress={handleContinue} style={{ marginBottom: 16 }} />
    </StandaloneWrapper>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 24,
  },
  partnerInfo: {
    gap: 12,
  },
  partnerDescription: {
    color: mesaColorNames['global/grey/80 #2F3133'],
  },
  clearButton: {
    color: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'],
    textAlign: 'center',
    marginBottom: 40,
  },
})
